import { msg } from "@lingui/core/macro";
import { createRoute, useParams } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { AuthPlaceholder } from "@/components/auth-placeholder";
import { PageContainer } from "@fleet/ui/page-container";
import { PersonDetailPage } from "@/features/domain/components/person-detail-page";
import { useI18n } from "@/providers/i18n-provider";

function PersonDetailRoutePage() {
  const { t } = useI18n();
  const params = useParams({ from: "/_app/people/$personId" });
  return (
    <AuthPlaceholder title={t(msg`Person`)} description={t(msg`Sign in to see this profile.`)}>
      <PageContainer maxWidth="3xl">
        <PersonDetailPage personId={params().personId} />
      </PageContainer>
    </AuthPlaceholder>
  );
}

export const personDetailRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/people/$personId",
  component: PersonDetailRoutePage,
});
